<template>
    <div id="mElaborationMobile-container" class="mElaborationMobile-container" v-observe-visibility="startAnimate">
        <div class="lineMobile" id="neonShadowMobile"></div>
        <div class="mElaborationMobileContent-container">
            <div class="firstPart-elaborationMobile">
                <img class="processOf-Mobile" :src="processOf" alt="Proceso de elaboración de la NUEVA Tecate 0.0">
                <img class="elaborationContainer-Mobile" :src="elaborationContainer" alt="Banner elaboración">
                <img class="elaborationText-Mobile" :src="elaborationText" alt="Tecate 0.0 utiliza un proceso nuevo e innovador en México, que logra elaborar la cerveza con todo el sabor y sin producir alcohol, haciendo de este un proceso más rápido">
                <img class="tanksImg-Mobile" :src="tanksImg" alt="Tanques- El proceso de Tecate 0.0 gasta menos agua, vapor y electricidad haciéndola mas amigable con el medio ambiente">
            </div>
            <div class="stepsElaboration-Mobile">
                <div class="stepsElaboration1-Mobile">
                    <div class="textsElaborationMobile1">
                        <!-- <img class="textInfo1-Mobile" :src="ingredients" alt="Ingredientes: se agregan los ingredientes de una cerveza: malta, almidón de maíz, agua y levadura"> -->
                        <span style="position: relative;">
                            <div class="textsElaborationMobile-numberContainer1">
                                <p class="textsElaborationMobile-Number">1</p>
                            </div>
                        </span>
                        <p class="textsElaborationMobile-cardTittle">INGREDIENTES</p>
                        <p class="textsElaborationMobile-cardInfo">SE AGREGAN LOS INGREDIENTES DE UNA CERVEZA: MALTA, ALMIDÓN DE MAÍZ, AGUA Y LEVADURA.</p>
                        <div class="trienguleMobile-Elaboration1"></div>
                    </div>
                    <div class="textsElaborationMobile2">
                        <!-- <img class="textInfo2-Mobile" :src="cooking" alt="Cocción: se produce Tecate original pero a una temperatura más baja para no producir alcohol, este proceso produce la cosistencia de una cerveza y su aroma pero sin alcohol"> -->
                        <span style="position: relative;">
                            <div class="textsElaborationMobile-numberContainer2">
                                <p class="textsElaborationMobile-Number">2</p>
                            </div>
                        </span>
                        <p class="textsElaborationMobile-cardTittle">COCCIÓN</p>
                        <p class="textsElaborationMobile-cardInfo">SE PRODUCE TECATE ORIGINAL PERO A UNA TEMPERATURA MÁS BAJA PARA NO PRODUCIR ALCOHOL, ESTE PROCESO PRODUCE LA CONSISTENCIA DE UNA CERVEZA Y SU AROMA PERO SIN ALCOHOL.</p>
                        <div class="trienguleMobile-Elaboration2"></div>
                    </div>
                    <div class="textsElaborationMobile3">
                        <!-- <img class="textInfo3-Mobile" :src="secondAction" alt="2da Cocción: nuestro maestro cervecero la armoniza y la embotella"> -->
                        <span style="position: relative;">
                            <div class="textsElaborationMobile-numberContainer3">
                                <p class="textsElaborationMobile-Number">3</p>
                            </div>
                        </span>
                        <p class="textsElaborationMobile-cardTittle">2da COCCIÓN</p>
                        <p class="textsElaborationMobile-cardInfo">NUESTRO MAESTRO CERVECERO  LA ARMONIZA Y LA EMBOTELLA.</p>
                        <div class="trienguleMobile-Elaboration3"></div>
                    </div>
                    <div class="textsElaborationMobile4">
                        <!-- <img class="textInfo4-Mobile" :src="smell" alt="Aroma: llega a ti"> -->
                        <span style="position: relative;">
                            <div class="textsElaborationMobile-numberContainer4">
                                <p class="textsElaborationMobile-Number">4</p>
                            </div>
                        </span>
                        <p class="textsElaborationMobile-cardTittle">AROMA</p>
                        <p class="textsElaborationMobile-cardInfo">LLEGA A TI.</p>
                        <div class="trienguleMobile-Elaboration4"></div>
                    </div>
                </div>
                <div>
                    <img class="bottleEP-Mobile" :src="bottleEP" alt="Botella Tecate 0.0">
                </div>
            </div>
            <div class="newText-Mobile">
                <p class="subNewText1-Mobile">¡Y LISTO!</p>
                <p class="subNewText2-Mobile">
                    ASÍ ES COMO NACE NUESTRA NUEVA TECATE<br>
                </p>
                <p class="subNewText3-Mobile">
                    <b>CON UN GRADO DE ALCOHOL DE 0.0%</b>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import processOf from '@/assets/tkt-elaboration/PROCESO-DE.png';
import elaborationContainer from '@/assets/tkt-elaboration/ELABORACION-BACK.png';
import elaborationText from '@/assets/tkt-elaboration/ELABORACION-PALABRA.png';
import tanksImg from '@/assets/tkt-elaboration/IMG-Tanques2.png';
import ingredients from '@/assets/tkt-elaboration/INGREDIENTES.png';
import cooking from '@/assets/tkt-elaboration/Coccion.png';
import secondAction from '@/assets/tkt-elaboration/2DA-COCCION.png';
import smell from '@/assets/tkt-elaboration/Aroma.png';
import bottleEP from '@/assets/beer/BOTTLE_TECATE.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "MobileElaboration",
    data() {
        return {
            animate: false,
            tanksImg,
            processOf,
            elaborationContainer,
            elaborationText,
            ingredients,
            cooking,
            secondAction,
            smell,
            bottleEP
        };
    },

    computed: {
        ...mapGetters(["isLoaded"]),
    },

    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
    },

    components: {},
    mounted() {
    },

    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName() == 'Safari') {
            this.isSafari = true
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/MobileElaboration.scss";
</style>